function digitsOf(n: number): number[] {
  return String(Math.abs(n))
    .split("")
    .map((ch) => ch.charCodeAt(0) - 48)
    .filter((d) => d >= 0 && d <= 9);
}

function reduceToSingleDigit(n: number): number {
  let total = Math.abs(n);
  while (total >= 10) {
    total = digitsOf(total).reduce((acc, d) => acc + d, 0);
  }
  return total || 1;
}

export function getDailyNumber(now: Date = new Date()) {
  const total = now.getDate() + (now.getMonth() + 1) + now.getFullYear();
  return reduceToSingleDigit(total);
}

export type DailyGuidance = {
  number: number;
  title: string;
  focus: string;
  meditation: string;
  affirmation: string;
  action: string;
};

const DAILY_GUIDANCE: Record<number, Omit<DailyGuidance, "number">> = {
  1: {
    title: "Başlangıç ve cesaret",
    focus: "Niyet belirle, ilk adımı at.",
    meditation:
      "3 dakika dik otur. Nefesi burundan al-ver. Her nefeste 'başlıyorum' de.",
    affirmation: "Ben yeni bir sayfa açmaya hazırım.",
    action: "Tek bir işi seç ve 20 dakika kesintisiz ilerlet.",
  },
  2: {
    title: "Uyum ve ilişkiler",
    focus: "Dinle, yumuşak iletişim kur.",
    meditation:
      "Kalp bölgesine elini koy. 10 nefes boyunca şefkat hissini büyüt.",
    affirmation: "Ben sevgiyle iş birliği kurarım.",
    action: "Bir kişiye içten bir teşekkür mesajı yaz.",
  },
  3: {
    title: "İfade ve neşe",
    focus: "Yaratıcılığını görünür kıl.",
    meditation:
      "2 dakika gülümseme meditasyonu: yüz kaslarını yumuşat, neşeyi davet et.",
    affirmation: "Ben kendimi özgürce ifade ederim.",
    action: "Kısa bir not yaz: Bugün neyi paylaşmak istiyorum?",
  },
  4: {
    title: "Düzen ve sağlam zemin",
    focus: "Plan yap, sistemi kur.",
    meditation:
      "4-4-4 nefes: 4 sayıda al, 4 tut, 4 ver. 6 tur tekrar et.",
    affirmation: "Ben güvenli bir temel inşa ederim.",
    action: "Evin/işinin bir köşesini sadeleştir ve düzenle.",
  },
  5: {
    title: "Değişim ve özgürlük",
    focus: "Esne, yeni olana açıl.",
    meditation:
      "Omuzları gevşet. Nefesle birlikte bedenin hareket etmesine izin ver.",
    affirmation: "Ben değişimi güvenle karşılarım.",
    action: "Rutinde küçük bir yenilik yap: farklı bir rota, farklı bir seçim.",
  },
  6: {
    title: "Şifa ve sorumluluk",
    focus: "Kendine iyi bak, dengeyi gözet.",
    meditation:
      "5 dakika beden taraması: baştan ayağa gevşemeyi fark et.",
    affirmation: "Ben kendimi ve sevdiklerimi sevgiyle korurum.",
    action: "Bir şefkat eylemi seç: kendine veya birine destek ol.",
  },
  7: {
    title: "İçgörü ve derinleşme",
    focus: "Sessizlik, sezgi, analiz.",
    meditation:
      "Nefesi yavaşlat. 21 nefes say. Zihni zorlamadan izlemeye devam et.",
    affirmation: "Ben iç sesimi güvenle duyarım.",
    action: "15 dakika ekranlardan uzak kal ve bir konu üzerine düşün.",
  },
  8: {
    title: "Güç ve bolluk",
    focus: "Hedefleri somutlaştır.",
    meditation:
      "Dik dur. Nefes alırken 'güç', verirken 'hizmet' kelimesini içinden söyle.",
    affirmation: "Ben değeri yaratır ve bereketi yönetirim.",
    action: "Bir finans/iş hedefini yaz ve ilk gerçekçi adımı belirle.",
  },
  9: {
    title: "Tamamlama ve bırakış",
    focus: "Bitir, affet, sadeleş.",
    meditation:
      "Kalbinden ışık yayıldığını hayal et. Eski yükleri nefesle bırak.",
    affirmation: "Ben geçmişi sevgiyle serbest bırakırım.",
    action: "Yarım kalan tek bir işi tamamla ya da kapat.",
  },
};

export function getDailyGuidance(now: Date = new Date()): DailyGuidance {
  const number = getDailyNumber(now);
  const entry = DAILY_GUIDANCE[number] ?? DAILY_GUIDANCE[1];
  return { number, ...entry };
}
